export default {"src":"/uk/_next/static/media/spot-tick.a8b32ece.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};